import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useEffect, useRef, useState } from "react";
import { Password } from "primereact/password";
import { useHistory } from "react-router-dom";
import imagineHomeService from "../imagineHomeService";
import { Toast } from "primereact/toast";
import { useParams } from "react-router-dom";
import { Dialog } from "primereact/dialog";
import { Calendar } from "primereact/calendar";
import PhoneInput, { isValidPhoneNumber, getCountryCallingCode, parsePhoneNumber } from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { validateEmail } from "../../../utilities/utillFunction";
import moment from "moment";

const AddCompanyOrgnization = () => {
    const serviceId = localStorage.getItem("serviceId");
    const [isLoading, setIsLoading] = useState(false);
    const [dialogForError, setdialogForError] = useState(false);
    const [error, setError] = useState("");
    const [isPasswordChanging, setIsPasswordChanging] = useState(false);
    const [orgnizationDesignerInfo, setOrgnizationDesignerInfo] = useState({
        serviceId: serviceId,
        name: "",
        ein: "",
        tan: "",
        merchantId: "",
        merchantUrl: "",
        userName: "",
        image: null,
        payEnabled: undefined,
        orgLegalName: "",
        startDate: "",
        empCount: "",
        annualRevenue: "",
        salesRevenuePercentage: "",
        firstName: "",
        lastName: "",
        mobNumber: "",
        email: "",
    });

    const serviceData = JSON.parse(localStorage.getItem("service"));
    const defcountryCode = {
        india: "IN",
        mexico: "MX",
        canada: "CA",
        usa: "US",
    };

    let defCode = serviceData.location && serviceData.location.operatingCountry ? defcountryCode[serviceData.location.operatingCountry] : serviceData.customer && serviceData.customer.region ? serviceData.customer.region.toUpperCase() : "IN";

    const params = useParams();
    const [isEditMode] = useState(!!params.id);
    useEffect(() => {
        if (isEditMode) {
            fetchSingleTradePartnerData(params.id);
        }
    }, []);

    const toast = useRef(null);
    const [paymentGateway, setPaymentGateway] = useState("Card Pointe");
    const [logoFile, setLogoFile] = useState();

    const history = useHistory();

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const fileInputRef = useRef(null);
    const gatewayOptions = ["Card Pointe"];

    const currentYear = new Date().getFullYear();
    const maxYear = currentYear;
    const minYear = 1950;
    const yearRange = `${minYear}:${maxYear}`;

    const months = [
        { label: "January", value: 0 },
        { label: "February", value: 1 },
        { label: "March", value: 2 },
        { label: "April", value: 3 },
        { label: "May", value: 4 },
        { label: "June", value: 5 },
        { label: "July", value: 6 },
        { label: "August", value: 7 },
        { label: "September", value: 8 },
        { label: "October", value: 9 },
        { label: "November", value: 10 },
        { label: "December", value: 11 },
    ];

    const editDisabledFields = ["firstName", "lastName", "mobNumber", "email"];

    const isFieldDisabled = (field) => {
        return isEditMode && editDisabledFields.includes(field);
    };
    const handleResetForm = () => {
        setOrgnizationDesignerInfo({
            serviceId: serviceId,
            name: "",
            ein: "",
            tan: "",
            merchantId: "",
            merchantUrl: "",
            userName: "",
            image: null,
            payEnabled: false,
            orgLegalName: "",
            startDate: "",
            empCount: "",
            annualRevenue: "",
            salesRevenuePercentage: "",
            firstName: "",
            lastName: "",
            mobNumber: "",
            email: "",
        });
        setLogoFile(null);
        setPassword("");
        setConfirmPassword("");
        setdialogForError(false);
    };

    const fetchSingleTradePartnerData = async (id) => {
        try {
            const res = await imagineHomeService.getSingleTradePartnerInformation({
                serviceId,
                orgId: id,
            });
            if (res.success && res.responseCode === 200 && Object.keys(res.responseData).length > 0) {
                const data = res.responseData;
                setOrgnizationDesignerInfo({
                    serviceId: data.serviceId,
                    name: data.name || "",
                    ein: data.ein || "",
                    tan: data.tan || "",
                    merchantId: data.merchantId || "",
                    merchantUrl: data.merchantUrl || "",
                    userName: data.userName || "",
                    image: data.image || null,
                    payEnabled: data?.payEnabled,
                    orgLegalName: data?.orgLegalName || "",
                    startDate: data.startDate ? moment(data.startDate).toDate() : "",
                    empCount: data?.empCount || "",
                    annualRevenue: data?.annualRevenue || "",
                    salesRevenuePercentage: data?.salesRevenuePercentage || "",
                    firstName: data?.ownerInfo?.firstName || "",
                    lastName: data?.ownerInfo?.lastName || "",
                    mobNumber: data?.ownerInfo ? data?.ownerInfo?.mobNumber || "" : "",
                    email: data?.ownerInfo?.email || "",
                });

                setPaymentGateway(data.paymentGateway || "");
                setPassword(data.password || "");
                setConfirmPassword(data.password || "");

                // ✅ Show logo if image exists
                if (data.image && data.image.trim() !== "null") {
                    setLogoFile(`${process.env.REACT_APP_IMAGE_STATIC_URL}/${encodeURIComponent(data.image)}`);
                } else {
                    // optional fallback (dummy logo or default color background)
                    setLogoFile(null);
                }
            } else {
                showError("Not found Trade Partner with this Id", res.message);
            }
        } catch (error) {
            console.error("❌ Error fetching trade partner data:", error);
        }
    };

    const handleClick = () => {
        fileInputRef.current.click();
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const previewUrl = URL.createObjectURL(file);
            setLogoFile(previewUrl);
            setOrgnizationDesignerInfo((prev) => ({ ...prev, image: file }));
        }
    };

    const showError = (summary = "", message) => {
        toast.current.show({
            severity: "error",
            summary: !summary ? "Validation Error" : summary,
            detail: message,
            life: 3000,
        });
    };
    const getCountryCodeFromMob = (mob) => {
        let mobileCountry = parsePhoneNumber(mob);
        if (mobileCountry && mobileCountry.country) {
            return getCountryCallingCode(mobileCountry.country);
        }
        return null;
    };

    const validateForm = () => {
        let isValid = true;

        const urlRegex = new RegExp(
            "^(https?:\\/\\/)?" + // optional protocol
                "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // domain name
                "localhost|" + // or localhost
                "((\\d{1,3}\\.){3}\\d{1,3}))" + // or IPv4
                "(\\:\\d+)?" + // optional port
                "(\\/[-a-z\\d%_.~+]*)*" + // path
                "(\\?[;&a-z\\d%_.~+=-]*)?" + // query string
                "(\\#[-a-z\\d_]*)?$",
            "i"
        );

        // if (!orgnizationDesignerInfo.name.trim()) {
        //     showError("Business Information", "Trade Partner Name is required");
        //     isValid = false;
        //     return isValid;
        // }
        if (!orgnizationDesignerInfo?.orgLegalName.trim()) {
            showError("Business Information", "Legal Name of Business is required");
            isValid = false;
            return isValid;
        }
        if (!orgnizationDesignerInfo.ein.trim()) {
            showError("Business Information", "EIN is required");
            isValid = false;
            return isValid;
        }
        if (orgnizationDesignerInfo?.startDate === "") {
            showError("Business Information", "Date Stated is required");
            isValid = false;
            return isValid;
        }

        if (orgnizationDesignerInfo?.empCount === undefined || orgnizationDesignerInfo?.empCount === null || orgnizationDesignerInfo?.empCount === "" || Number.isNaN(orgnizationDesignerInfo?.empCount)) {
            showError("Business Information", "No of Employees is required");
            isValid = false;
            return isValid;
        }
        if (orgnizationDesignerInfo?.annualRevenue === undefined || orgnizationDesignerInfo?.annualRevenue === null || orgnizationDesignerInfo?.annualRevenue === "" || Number.isNaN(orgnizationDesignerInfo?.annualRevenue)) {
            showError("Business Information", "Annual Revenue is required");
            isValid = false;
            return isValid;
        }
        // if (
        //     orgnizationDesignerInfo?.salesRevenuePercentage === undefined ||
        //     orgnizationDesignerInfo?.salesRevenuePercentage === null ||
        //     Number.isNaN(orgnizationDesignerInfo?.salesRevenuePercentage)
        // ) {
        //     showError("Business Information", "Percentage of Revenue from furniture Sales is required");
        //     isValid = false;
        //     return isValid;
        // }

        // if (
        // orgnizationDesignerInfo.salesRevenuePercentage < 1 ||
        // orgnizationDesignerInfo.salesRevenuePercentage > 100
        // ) {
        // showError("Business Information","Please enter a percentage between 1 and 100");
        // return;
        // }

        if (orgnizationDesignerInfo.payEnabled === undefined) {
            showError(null, "Please fill the required fields");
            isValid = false;
            return isValid;
        }
        if (orgnizationDesignerInfo.payEnabled) {
            if (paymentGateway === "Card Pointe") {
                const msg = " is required when payment transactions are enabled.";
                if (!orgnizationDesignerInfo.merchantId.trim()) {
                    showError("Payment Gateway Information", `Merchant Id${msg}`);
                    isValid = false;
                    return isValid;
                }
                if (!orgnizationDesignerInfo.merchantUrl.trim()) {
                    showError("Payment Gateway Information", `Merchant URL${msg}`);
                    isValid = false;
                    return isValid;
                }
                if (!urlRegex.test(orgnizationDesignerInfo.merchantUrl)) {
                    showError("Payment Gateway Information", "Please Enter the valid Merchant URL.");
                    isValid = false;
                    return isValid;
                }
                if (!orgnizationDesignerInfo.userName.trim()) {
                    showError("Payment Gateway Information", `User Name${msg}`);
                    isValid = false;
                    return isValid;
                }
                if (!password.trim()) {
                    showError("Payment Gateway Information", `Password${msg}`);
                    isValid = false;
                    return isValid;
                }
                if (!confirmPassword?.trim()) {
                    showError("Payment Gateway Information", `Confirm Password${msg}`);
                    isValid = false;
                    return isValid;
                } else if (password !== confirmPassword) {
                    showError("Payment Gateway Information", "Password and Confirm Password do not match");
                    isValid = false;
                    return isValid;
                }
            }
        }
        if (!orgnizationDesignerInfo?.firstName.trim()) {
            showError("Owner Information", "First Name is required");
            isValid = false;
            return isValid;
        }
        if (!orgnizationDesignerInfo?.lastName.trim()) {
            showError("Owner Information", "Last Name is required");
            isValid = false;
            return isValid;
        }

        if (orgnizationDesignerInfo.firstName === orgnizationDesignerInfo.lastName) {
            showError("Owner Information", "First Name and Last Name should not be same");
            isValid = false;
            return isValid;
        }

        if (orgnizationDesignerInfo.mobNumber === undefined || !orgnizationDesignerInfo?.mobNumber?.trim()) {
            showError("Owner Information", "Phone Number is required");
            isValid = false;
            return isValid;
        }
        if (!isValidPhoneNumber(orgnizationDesignerInfo?.mobNumber)) {
            showError("Owner Information", "Please Enter a valid Phone Number");
            isValid = false;
            return isValid;
        }
        if (!getCountryCodeFromMob(orgnizationDesignerInfo?.mobNumber)) {
            showError("Owner Information", "Please Enter a valid Phone Number");
            isValid = false;
            return isValid;
        }

        if (!orgnizationDesignerInfo?.email.trim()) {
            showError("Owner Information", "Email is required");
            isValid = false;
            return isValid;
        }

        if (!validateEmail(orgnizationDesignerInfo?.email)) {
            showError("Owner Information", "Please enter a valid email");
            isValid = false;
            return isValid;
        }

        return isValid;
    };

    const handleSubmitDesignerOrgnizationInfo = async () => {
        if (!validateForm()) return;

        const formData = new FormData();
        formData.append("image", orgnizationDesignerInfo.image);
        formData.append("name", orgnizationDesignerInfo?.name?.trim());
        formData.append("serviceId", orgnizationDesignerInfo.serviceId);
        formData.append("paymentGateway", paymentGateway);
        formData.append("userName", orgnizationDesignerInfo.userName?.trim());
        formData.append("ein", orgnizationDesignerInfo.ein?.trim());
        formData.append("tan", orgnizationDesignerInfo.tan);
        formData.append("merchantId", orgnizationDesignerInfo.merchantId?.trim());
        formData.append("merchantUrl", orgnizationDesignerInfo.merchantUrl?.trim());
        formData.append("password", password?.trim());
        formData.append("payEnabled", orgnizationDesignerInfo.payEnabled);
        formData.append("orgLegalName", orgnizationDesignerInfo.orgLegalName?.trim());
        formData.append("startDate", moment(orgnizationDesignerInfo.startDate).format("MM-DD-YYYY"));
        formData.append("empCount", +orgnizationDesignerInfo.empCount);
        formData.append("annualRevenue", +orgnizationDesignerInfo.annualRevenue);
        formData.append("salesRevenuePercentage", +orgnizationDesignerInfo.salesRevenuePercentage);
        formData.append("firstName", orgnizationDesignerInfo.firstName?.trim());
        formData.append("lastName", orgnizationDesignerInfo.lastName?.trim());
        formData.append("email", orgnizationDesignerInfo.email?.toLowerCase());

        formData.append("mobNumber", orgnizationDesignerInfo.mobNumber);
        let countryCode = getCountryCodeFromMob(orgnizationDesignerInfo?.mobNumber);
        formData.append("countryCode", "+" + countryCode);

        try {
            setIsLoading(true);

            let res;
            if (isEditMode) {
                formData.append("orgId", params.id);
                res = await imagineHomeService.updateTradePartnerInformation(formData);
            } else {
                res = await imagineHomeService.addCompanyOrgnizationInformation(formData);
            }

            if (res.responseCode === 200) {
                toast.current.show({
                    summary: "Success",
                    severity: "success",
                    detail: res.message,
                });

                // 🔄 Consistent navigation
                setTimeout(() => {
                    history.push("/trade-partner");
                }, 2000);
            } else {
                setError(res.message);
                setdialogForError(true);
            }
        } catch (error) {
            console.error("❌ Error submitting form:", error);
            toast.current.show({
                summary: "Failed",
                severity: "error",
                detail: "Something went wrong. Please try again.",
                life: 4000,
            });
        } finally {
            setIsLoading(false);
        }
    };

    const isPasswordChaning = (e) => {
        setIsPasswordChanging(true);
        setConfirmPassword("");
        setPassword(e.target.value);
    };

    const ConfirmPasswordBlock = (
        <div className="col-12 md:col-6 lg:col-4">
            <label htmlFor="confirmPassword" className="block editFeatureLabel mb-2">
                Confirm Password
            </label>
            <Password feedback={false} id="confirmPassword" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} toggleMask inputClassName="w-full addFeatureInput" className="w-full" />
        </div>
    );

    const getYearOptions = () => {
        const [startYear, endYear] = yearRange.split(":").map(Number);
        return Array.from({ length: endYear - startYear + 1 }, (_, i) => ({
            label: startYear + i,
            value: startYear + i,
        })).sort((a, b) => b.value - a.value);
    };

    return (
        <>
            <Toast ref={toast} />
            <div className="px-2" style={{ fontFamily: "Montserrat" }}>
                <div className="flex my-2 align-content-center" style={{ gap: 10, fontFamily: "Larken" }}>
                    <img onClick={() => history.push("/trade-partner")} src="/images/Back.svg" alt="Back" className="cursor-pointer" />
                    <h2 className="m-0 featureHeading">{isEditMode ? "Edit" : "Add"} Trade Partner</h2>
                </div>

                <form onSubmit={handleSubmitDesignerOrgnizationInfo} className="grid">
                    <div className="col-12 flex flex-column align-items-center justify-content-center p-2 sm:p-5">
                        <div onClick={handleClick} style={{ background: logoFile ? `url(${logoFile}) center/cover no-repeat` : "#E5E1CF", width: "130px", height: "130px", cursor: "pointer" }} className="relative border-circle flex align-items-center justify-content-center">
                            <div
                                className="absolute border-circle flex align-items-center justify-content-center"
                                style={{
                                    bottom: "8px",
                                    right: "8px",
                                    width: "24px",
                                    height: "24px",
                                    background: "#9AAB89",
                                    cursor: "pointer",
                                    color: "#47422F",
                                }}
                                // onClick={handleClick}
                            >
                                <i className="pi pi-pencil text-sm"></i>
                            </div>

                            <input type="file" accept=".png,.jpg,.jpeg" ref={fileInputRef} style={{ display: "none" }} onChange={handleFileChange} />
                        </div>
                        <label className="editFeatureLabel mt-1 sm:mt-4">Company LOGO</label>
                        {/* {errors.image && <Message severity="error" text={errors.image} />} */}
                    </div>

                    <div className="col-12">
                        <label className="inline-block featureHeading mb-2" style={{ fontSize: "28px" }}>
                            Business Information
                        </label>
                    </div>

                    {/* Name */}
                    {/* <div className=" col-12 md:col-6 lg:col-4">
                        <label htmlFor="name" className="block editFeatureLabel mb-2" aria-required>
                            Trade Partner Name <span style={{ color: 'red', fontSize: '1.3rem' }}>*</span>
                        </label>
                        <InputText id="name" className="w-full addFeatureInput" value={orgnizationDesignerInfo.name} onChange={(e) => setOrgnizationDesignerInfo((prev) => ({ ...prev, name: e.target.value }))} required={true} />
                    </div> */}

                    {/* Legal Name of Business */}
                    <div className=" col-12 md:col-6 lg:col-4">
                        <label htmlFor="orgLegalName" className="block editFeatureLabel mb-2" aria-required>
                            Legal Name of Business <span style={{ color: "red", fontSize: "1.3rem" }}>*</span>
                        </label>
                        <InputText id="orgLegalName" className="w-full addFeatureInput" value={orgnizationDesignerInfo.orgLegalName} onChange={(e) => setOrgnizationDesignerInfo((prev) => ({ ...prev, orgLegalName: e.target.value }))} required={true} />
                    </div>

                    {/* EIN */}
                    <div className="col-12 md:col-6 lg:col-4">
                        <label htmlFor="ein" className="block editFeatureLabel mb-2">
                            EIN <span style={{ color: "red", fontSize: "1.3rem" }}>*</span>
                        </label>
                        <InputText id="ein" className="w-full addFeatureInput" value={orgnizationDesignerInfo.ein} onChange={(e) => setOrgnizationDesignerInfo((prev) => ({ ...prev, ein: e.target.value }))} />
                    </div>

                    {/* Date Started*/}
                    <div className=" col-12 md:col-6 lg:col-4">
                        <label htmlFor="startDate" className="block editFeatureLabel mb-2" aria-required>
                            Date Started <span style={{ color: "red", fontSize: "1.3rem" }}>*</span>
                        </label>
                        <Calendar
                            readOnlyInput
                            value={orgnizationDesignerInfo.startDate}
                            onChange={(e) => setOrgnizationDesignerInfo((prev) => ({ ...prev, startDate: e.value }))}
                            showIcon
                            className=" flex align-items-center addFeatureInput"
                            monthNavigator
                            yearNavigator
                            yearRange={yearRange}
                            dateFormat="mm-dd-yy"
                            monthNavigatorTemplate={(options) => (
                                <Dropdown
                                    value={options.value} // current month index
                                    options={months}
                                    optionLabel="label"
                                    optionValue="value" // month options
                                    // onChange={(e) => options.onChange(e.value)} // updates calendar
                                    onChange={(e) => {
                                        // Update the calendar internal view
                                        options.onChange(e.value);
                                        // Also update your state
                                        setOrgnizationDesignerInfo((prev) => {
                                            const newDate = new Date(prev.startDate || new Date());
                                            newDate.setMonth(e.value);
                                            return { ...prev, startDate: newDate };
                                        });
                                    }}
                                    className="mr-2"
                                    style={{
                                        borderRadius: "20px",
                                        border: "2px solid #9AAB89 !important",
                                        boxShadow: "none !important",
                                        lineHeight: "0.5rem",
                                    }}
                                />
                            )}
                            yearNavigatorTemplate={(options) => (
                                <Dropdown
                                    value={options.value} // current year
                                    options={getYearOptions()} // generate years dynamically
                                    optionLabel="label"
                                    optionValue="value"
                                    onChange={(e) => {
                                        // Update the calendar internal view
                                        options.onChange(e.value);
                                        // Also update your state
                                        setOrgnizationDesignerInfo((prev) => {
                                            const newDate = new Date(prev.startDate || new Date());
                                            newDate.setFullYear(e.value);
                                            return { ...prev, startDate: newDate };
                                        });
                                    }}
                                    style={{
                                        borderRadius: "20px",
                                        border: "2px solid #9AAB89 !important",
                                        boxShadow: "none !important",
                                        lineHeight: "0.5rem",
                                    }}
                                />
                            )}
                        />
                    </div>

                    {/* No of Employees*/}
                    <div className=" col-12 md:col-6 lg:col-4">
                        <label htmlFor="empCount" className="block editFeatureLabel mb-2" aria-required>
                            No. of Employees <span style={{ color: "red", fontSize: "1.3rem" }}>*</span>
                        </label>
                        <InputText type="number" id="empCount" className="w-full addFeatureInput" value={orgnizationDesignerInfo.empCount ?? null} onChange={(e) => setOrgnizationDesignerInfo((prev) => ({ ...prev, empCount: e.target.value }))} required={true} />
                    </div>

                    {/* Annual Revenue*/}
                    <div className=" col-12 md:col-6 lg:col-4">
                        <label htmlFor="annualRevenue" className="block editFeatureLabel mb-2" aria-required>
                            Annual Revenue (in $)<span style={{ color: "red", fontSize: "1.3rem" }}>*</span>
                        </label>
                        <InputText type="number" id="annualRevenue" className="w-full addFeatureInput" value={orgnizationDesignerInfo.annualRevenue ?? null} onChange={(e) => setOrgnizationDesignerInfo((prev) => ({ ...prev, annualRevenue: e.target.value }))} prefix="$ " />
                    </div>

                    {/* % Revenue*/}
                    {/* <div className=" col-12 md:col-6 lg:col-4">
                        <label htmlFor="salesRevenuePercentage" className="block editFeatureLabel mb-2" aria-required>
                            % of Revenue from furniture Sales <span style={{ color: 'red', fontSize: '1.3rem' }}>*</span>
                        </label>
                            <InputText
                                type="number"
                                className="w-full addFeatureInput"
                                value={orgnizationDesignerInfo.salesRevenuePercentage}
                                onChange={(e) =>
                                    setOrgnizationDesignerInfo((prev) => ({
                                        ...prev,
                                        salesRevenuePercentage: e.target.value,
                                    }))
                                }
                                min={0}
                                max={100}
                            />
                    </div> */}
                    {/* TAN */}
                    {/* <div className="col-12 md:col-6 lg:col-4">
                        <label htmlFor="tan" className="block editFeatureLabel mb-2">
                            TAN
                        </label>
                        <InputText id="tan" className="w-full addFeatureInput" value={orgnizationDesignerInfo.tan} onChange={(e) => setOrgnizationDesignerInfo((prev) => ({ ...prev, tan: e.target.value }))} />
                    </div> */}

                    <div className="col-12">
                        <label className="inline-block featureHeading my-3" style={{ fontSize: "28px" }}>
                            Payment Gateway Information
                        </label>
                    </div>

                    {/* Payment Gateway */}
                    <div className="col-12 md:col-6 lg:col-4">
                        <label className="block editFeatureLabel mb-2">Payment Gateway</label>
                        <Dropdown value={paymentGateway} options={gatewayOptions} onChange={(e) => setPaymentGateway(e.value)} className="w-full addFeatureInput" />
                    </div>

                    {paymentGateway === "Card Pointe" && (
                        <>
                            {/* Merchant ID */}
                            <div className="col-12 md:col-6 lg:col-4">
                                <label htmlFor="merchantId" className="block editFeatureLabel mb-2">
                                    Merchant ID
                                </label>
                                <InputText id="merchantId" className="w-full addFeatureInput" value={orgnizationDesignerInfo.merchantId} onChange={(e) => setOrgnizationDesignerInfo((prev) => ({ ...prev, merchantId: e.target.value }))} />
                            </div>

                            {/* Merchant URL */}
                            <div className="col-12 md:col-6 lg:col-4">
                                <label htmlFor="merchantUrl" className="block editFeatureLabel mb-2">
                                    Merchant URL
                                </label>
                                <InputText id="merchantUrl" className="w-full addFeatureInput" value={orgnizationDesignerInfo.merchantUrl} onChange={(e) => setOrgnizationDesignerInfo((prev) => ({ ...prev, merchantUrl: e.target.value }))} />
                            </div>

                            {/* Username */}
                            <div className="col-12 md:col-6 lg:col-4">
                                <label htmlFor="username" className="block editFeatureLabel mb-2">
                                    User Name
                                </label>
                                <InputText id="username" className="w-full addFeatureInput" value={orgnizationDesignerInfo.userName} onChange={(e) => setOrgnizationDesignerInfo((prev) => ({ ...prev, userName: e.target.value }))} />
                            </div>

                            {/* Passwords */}
                            {/* (code from section 3 above for password + confirm password) */}
                            <div className="col-12 md:col-6 lg:col-4">
                                <label htmlFor="password" className="block editFeatureLabel mb-2">
                                    Password
                                </label>
                                <Password feedback={false} id="password" value={password} onChange={isEditMode ? isPasswordChaning : (e) => setPassword(e.target.value)} toggleMask inputClassName="w-full addFeatureInput" className="w-full" />
                            </div>

                            {isEditMode && isPasswordChanging && ConfirmPasswordBlock}

                            {!isEditMode && ConfirmPasswordBlock}
                        </>
                    )}

                    <div className="col-12">
                        <label className="inline-block featureHeading my-3" style={{ fontSize: "28px" }}>
                            Owner Information
                        </label>
                    </div>

                    <div className="col-12 md:col-6 lg:col-4">
                        <label htmlFor="firstName" className="block editFeatureLabel mb-2">
                            First Name <span style={{ color: "red", fontSize: "1.3rem" }}>*</span>
                        </label>
                        <InputText disabled={isFieldDisabled("firstName")} id="firstName" className="w-full addFeatureInput" value={orgnizationDesignerInfo.firstName} onChange={(e) => setOrgnizationDesignerInfo((prev) => ({ ...prev, firstName: e.target.value }))} />
                    </div>
                    <div className="col-12 md:col-6 lg:col-4">
                        <label htmlFor="lastName" className="block editFeatureLabel mb-2">
                            Last Name <span style={{ color: "red", fontSize: "1.3rem" }}>*</span>
                        </label>
                        <InputText disabled={isFieldDisabled("lastName")} id="lastName" className="w-full addFeatureInput" value={orgnizationDesignerInfo.lastName} onChange={(e) => setOrgnizationDesignerInfo((prev) => ({ ...prev, lastName: e.target.value }))} />
                    </div>
                    <div className="col-12 md:col-6 lg:col-4">
                        <label htmlFor="mobNumber" className="block editFeatureLabel mb-2">
                            Mobile Phone Number <span style={{ color: "red", fontSize: "1.3rem" }}>*</span>
                        </label>
                        <PhoneInput
                            id="mobNumber"
                            disabled={isFieldDisabled("mobNumber")}
                            className={`w-full p-inputtext p-component addFeatureInput  ${isEditMode ? "phone-input--disabled" : ""}`}
                            inputClassName="w-full h-full"
                            value={orgnizationDesignerInfo.mobNumber}
                            onChange={(value) => setOrgnizationDesignerInfo((prev) => ({ ...prev, mobNumber: value }))}
                            international
                            defaultCountry={defCode}
                        />
                    </div>
                    <div className="col-12 md:col-6 lg:col-4">
                        <label htmlFor="email" className="block editFeatureLabel mb-2">
                            E-mail Address <span style={{ color: "red", fontSize: "1.3rem" }}>*</span>
                        </label>
                        <InputText disabled={isFieldDisabled("email")} id="email" className="w-full addFeatureInput" value={orgnizationDesignerInfo.email} onChange={(e) => setOrgnizationDesignerInfo((prev) => ({ ...prev, email: e.target.value }))} />
                    </div>
                    <div className="col-12 flex align-items-start sm:align-items-center mt-2">
                        <label
                            className=""
                            style={{
                                fontSize: "14px",
                                fontFamily: "Larken",
                                color: "var(--Cedar, #47422F)",
                                fontStyle: "normal",
                                fontWeight: "600",
                                lineHeight: "20px",
                                letterSpacing: "1.44px",
                            }}
                        >
                            Is this merchant approved to process payment transactions? <span style={{ color: "red", fontSize: "1.3rem" }}>*</span>
                        </label>
                        <div className="p-0 mx-1 sm:mx-2">
                            <Button
                                type="button"
                                onClick={() => setOrgnizationDesignerInfo((prev) => ({ ...prev, payEnabled: true }))}
                                label="YES"
                                icon=""
                                className="p-button-rounded p-button-info font-Gerstner-ProgramRegular charcoal-color"
                                style={{ textAlign: "center", letterSpacing: "1.44px", backgroundColor: orgnizationDesignerInfo.payEnabled ? "#9AAB89" : "transparent", border: "1px solid #9AAB89", width: "40px", height: "30px" }}
                            />
                        </div>
                        <div className="p-0">
                            <Button
                                type="button"
                                onClick={() => setOrgnizationDesignerInfo((prev) => ({ ...prev, payEnabled: false }))}
                                label="NO"
                                className="p-button-rounded p-button-info font-Gerstner-ProgramRegular charcoal-color"
                                style={{ textAlign: "center", letterSpacing: "1.44px", backgroundColor: orgnizationDesignerInfo.payEnabled === false ? "#BFAD5B" : "transparent", border: "1px solid #BFAD5B", width: "40px", height: "30px" }}
                            />
                        </div>
                    </div>
                </form>

                <div className="border-1 my-4" style={{ border: "1px solid #9AAB89" }}></div>

                {/* Action buttons */}
                <div className="flex justify-content-end gap-3 mt-4">
                    <Button
                        label="Cancel"
                        onClick={() => history.push("/trade-partner")}
                        style={{
                            width: "169px",
                            height: "44px",
                            borderRadius: "20px",
                            border: "1px solid #9AAB89",
                            background: "transparent",
                            color: "#47422F",
                            padding: "12px 0",
                        }}
                        className="flex justify-center items-center hover:bg-gray-100"
                    />
                    <Button
                        label="Save"
                        onClick={handleSubmitDesignerOrgnizationInfo}
                        disabled={isLoading}
                        style={{
                            width: "169px",
                            height: "44px",
                            borderRadius: "20px",
                            border: isLoading ? "none" : "1px solid #47422F",
                            background: "#47422F",
                            color: "#fff",
                            padding: "12px 0",
                        }}
                        className="flex justify-center items-center ml-2 hover:bg-gray-800"
                    />
                </div>
            </div>

            <Dialog
                closable={false}
                draggable={false}
                visible={dialogForError}
                style={{
                    width: "30vw",
                    maxWidth: "45rem",
                    color: "#1D1B1C",
                }}
                breakpoints={{ "960px": "75vw", "640px": "95vw" }}
                footer={
                    <div className="grid w-full gap-3">
                        <div className="col-12 md:col-6">
                            <Button
                                className="p-button-rounded p-button-outlined font-Gerstner-ProgramRegular charcoal-color w-full"
                                label="Cancel"
                                onClick={() => setdialogForError(false)}
                                style={{
                                    letterSpacing: "1.44px",
                                }}
                            />
                        </div>
                        <div className="col-12 md:col-6">
                            <Button
                                label="Reset Form"
                                onClick={handleResetForm}
                                className="p-button-rounded font-Gerstner-ProgramRegular charcoal-color w-full"
                                style={{
                                    letterSpacing: "1.44px",
                                    backgroundColor: "#9AAB89",
                                    borderColor: "#9AAB89",
                                }}
                            />
                        </div>
                    </div>
                }
            >
                <p className="text-xl sm:text-2xl text-center" style={{ fontFamily: "Larken" }}>
                    Error: {error}
                </p>
            </Dialog>
        </>
    );
};
export default AddCompanyOrgnization;
